'use client';

import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { BlocksButton } from '@blocks-web-components/components/button/button';
import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import cx from 'classnames';

interface DrawerBackHeaderProps {
  className?: string;
  handleClose: () => void;
  isActive?: boolean;
  hideBackButton?: boolean;
}

export const DrawerBackHeader: FC<PropsWithChildren<DrawerBackHeaderProps>> = ({
  children,
  className,
  handleClose,
  isActive = false,
  hideBackButton = false
}) => {
  const buttonRef = useRef<BlocksButton>(null);

  //setTimeout because we need to wait for the drawer/modal to open to apply the focus
  useEffect(() => {
    if (isActive && buttonRef) {
      setTimeout(() => {
        buttonRef.current?.focus();
      }, 250);
    }
  }, [isActive, buttonRef]);

  return (
    <div
      slot="header"
      className={`${className} cat-u-display-flex`}
      style={{ gap: '8px' }}
    >
      <CatButton
        variant="ghost"
        data-testid="cat-back-button"
        hideText={true}
        className={cx({ 'd-none': hideBackButton })}
        onClick={handleClose}
        ref={buttonRef}
      >
        <CatIconArrowBack slot="before" />
      </CatButton>
      {children}
    </div>
  );
};
